/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Pipe, PipeTransform } from '@angular/core';
import { booleanToLabel } from '@app/utils';

@Pipe({
    name: 'label',
    standalone: true,
})
export class LabelPipe implements PipeTransform {
	transform(input: any, opts: any): any {
		return booleanToLabel(input, opts);
	}
}
